import { NestApiType, nestCall } from '../nestApi';

export async function GetWhatsappValidationStatus(shopId: number, templateId: string): Promise<any> {
  try {
    const result = await nestCall('post', NestApiType.MESSAGING, '/whatsapp/check-template-status', {}, '', {
      shopId,
      templateId,
    });

    return result;
  } catch (error) {
    console.error('Error checking WhatsApp validation status:', error);
    throw error;
  }
}

export async function SubmitWhatsappValidation(shopId: number, data: any): Promise<any> {
  try {
    const result = await nestCall('post', NestApiType.MESSAGING, '/whatsapp/submit-template', {}, '', {
      shopId,
      templateId: data.template_display_selector_id,
    });

    return {
      success: true,
      data: result,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.message,
    };
  }
}
